// Sovereign Multi-Tier High-Res Favicon & Cyber Monogram Resolver

export function getDomainFromUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www\./, '');
  } catch {
    return 'link';
  }
}

export function getFaviconCandidates(url, explicitFavicon) {
  const domain = getDomainFromUrl(url);
  const candidates = [];

  if (explicitFavicon && !explicitFavicon.includes('google.com/s2/favicons')) {
    candidates.push(explicitFavicon);
  }

  // Tier 1: High-res 64px Google S2 favicon service
  candidates.push(`https://www.google.com/s2/favicons?domain=${domain}&sz=64`);

  // Tier 2: DuckDuckGo Icons service
  candidates.push(`https://icons.duckduckgo.com/ip3/${domain}.ico`);

  // Tier 3: Unavatar high-res CDN
  candidates.push(`https://unavatar.io/${domain}?fallback=false`);

  return candidates;
}

// Generate deterministic cyber gradient colors for fallback monograms
export function getDomainCyberColor(domain) {
  let hash = 0;
  for (let i = 0; i < domain.length; i++) {
    hash = domain.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hues = [
    { bg: 'from-emerald-500/20 to-teal-700/30', border: 'border-emerald-500/40', text: 'text-emerald-400' },
    { bg: 'from-cyan-500/20 to-blue-700/30', border: 'border-cyan-500/40', text: 'text-cyan-400' },
    { bg: 'from-purple-500/20 to-indigo-700/30', border: 'border-purple-500/40', text: 'text-purple-400' },
    { bg: 'from-amber-500/20 to-orange-700/30', border: 'border-amber-500/40', text: 'text-amber-400' },
    { bg: 'from-rose-500/20 to-pink-700/30', border: 'border-rose-500/40', text: 'text-rose-400' },
    { bg: 'from-blue-500/20 to-indigo-700/30', border: 'border-blue-500/40', text: 'text-blue-400' },
  ];
  const idx = Math.abs(hash) % hues.length;
  return hues[idx];
}
